/**
 * ЕДГ-лотерея: клиентская проверка, есть ли в выборке «весь фильтр» явная клауза
 * «Готовность (регион) = Да». С 2026-09-11 сервер отправляет фильтр filter-режима
 * ДОСЛОВНО и больше НЕ добавляет и не вырезает эту клаузу сам — функция ниже нужна
 * только для мягкой подсказки в корзине («уйдут все отфильтрованные»), кнопку она
 * не блокирует.
 *
 * Плюс мелочи, общие для корзины и админки: текст «учётка не настроена» и сборка
 * строки-подписи из частей (пустые части не должны оставлять висячий разделитель).
 */

import type { FilterClause } from "@/api/client";

export const READINESS_REGION_FIELD = "readiness_region";
export const READINESS_YES = "Да";

export function hasReadinessRegionDa(filters: FilterClause[] | null | undefined): boolean {
  if (!filters) return false;
  return filters.some((c) => {
    if (c.field !== READINESS_REGION_FIELD) return false;
    if (c.operator === "eq") return String(c.value) === READINESS_YES;
    if (c.operator === "among") {
      return Array.isArray(c.value) && c.value.length === 1 && String(c.value[0]) === READINESS_YES;
    }
    return false;
  });
}

/** Текст «учётка не настроена» — один на корзину и админку (был продублирован строкой). */
export const LOTTERY_NOT_CONFIGURED = "Учётка mob-api не настроена (Админ → ЕДГ-лотерея).";

/**
 * Склеить непустые части через « · ». Нужна, чтобы в состоянии «не настроено» не
 * оставался висячий разделитель перед «Передано телефонов» — это первый экран,
 * который видит админ.
 */
export function joinDot(parts: Array<string | null | undefined | false>): string {
  return parts.filter((p): p is string => typeof p === "string" && p.trim() !== "").join(" · ");
}
